 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		86: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"customCollectionPage","18":"fc-components-main-components","19":"feed","20":"loginPage","21":"logoutPage","22":"magazineTagPage","23":"magazine_page","24":"myAccountPage","25":"newsletters_page_marketo","26":"notFoundPage","27":"offerPage","28":"playlistIndexPage","29":"playlistPage","30":"podcastPage","31":"post_page","32":"registerPage","33":"resetPasswordPage","34":"sitemapIndex","35":"sitemapPost","36":"stories","37":"subscribePage","38":"tagPage","39":"videoIndex","40":"videoPage","41":"views-containers-layouts-blank_layout-blank_layout","42":"views-containers-layouts-web_layout-web_layout","81":"MarketoNewsletterForm","82":"MicCarousel","83":"MicIcon","84":"MicMobileIconCarousel","85":"Success-SubmissionSuccess","87":"applications-most-innovative-companies","88":"brands_that_matter_2021","89":"brands_that_matter_page","90":"categoryLink","91":"components-BackgroundHighlight-BackgroundHighlight","92":"components-MultiTabList-MultiTabList","93":"components-QuickCarousel-QuickCarousel","94":"components-StickyBar-StickyBar","95":"components-all_feed-all_feed","96":"components-categories","97":"components-config-config","98":"components-editor_highlights-editor_highlights","99":"components-finite_scroll","100":"components-footer-footer","101":"components-franchise_intro-franchise_intro","102":"components-ibd_category-ibd_category","103":"components-image-image","104":"components-magazine_archive-magazine_archive","105":"components-masthead-masthead","106":"components-mcp_section-mcp_section","107":"components-mic_mobile_menu-mic_mobile_menu","108":"components-more-stories-component-more-stories-component","109":"components-newsletters-recaptcha","110":"components-notice","111":"components-piano-pianoBottomBanner","112":"components-podcast_tile-podcast_tile","113":"components-podcast_tile-podcast_tile_featured","114":"components-post-content-insert","115":"components-ranked","116":"components-recirc-recirc","117":"components-related_posts-related_posts","118":"components-related_slider-related_slider","119":"components-sectors_list-sectors_list","120":"components-social-social","121":"components-top_50-top_50","122":"components-top_50_shuffle-top_50_shuffle","123":"components-video_megatron-video_megatron","124":"components-video_module-utils-video_module_ads","125":"components-video_module-video_module","126":"containers-pages-list_landers-bwi-2020","127":"containers-pages-list_landers-ibd-2020","128":"containers-pages-list_landers-mic-2021","129":"content-innovation_festival_banner","130":"content-sponsor_bar","131":"fc-components-main-components-StickyBar-StickyBar","132":"fc-components-main-containers","133":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","134":"fc-components-main-containers-IbdLayout-IbdLayout","135":"fc-components-main-containers-MicLayout-MicLayout","136":"fc-components-main-containers-WciLayout-WciLayout","137":"fc-components-main-utils-ConditionalWrapper","138":"franchises-BtmApplyPage","139":"franchises-BwiApplyPage","140":"franchises-IbdApplyPage","141":"franchises-MicApplyPage","142":"franchises-NbttApplyPage","143":"franchises-WciApplyPage","144":"innovation_by_design_future_page","145":"innovation_by_design_page_franchise","146":"innovation_by_design_page_franchise_2023","147":"layouts","148":"layouts-mcp","149":"nav_main_menu-nav_main_menu","150":"package_article_list_entry","151":"packages-nav-package_sticky_nav","152":"post-content-sidebar","153":"topics"}[chunkId]||chunkId) + "." + {"1":"070d736d2790f9a26f9e","2":"710f3856786339d586ce","3":"8a72bcb469ebd21f0f25","4":"1f4641955271727a0a80","5":"36004907c682c4879957","6":"cb2988810ecfd4a811fd","7":"e7c7e03639bec34408b3","8":"ce26af64f9eac15fb421","9":"f172b3cb29994c9212de","10":"92e7a0dcee52108a9f26","11":"5e519357eba11e8586bc","12":"91063501363537550648","13":"8ee79b05f29aa7c5987b","14":"87828287879ad584c704","15":"34eeda3295883796067e","16":"cd73945e2944e659423d","17":"47b64f064b955eb8fcbc","18":"addd290a382aadac5524","19":"15c3caa17b7ac705cf20","20":"4d2f932840262970c81c","21":"2eba40f9f82a01652b4b","22":"75b1d7e030e4b1584fa2","23":"2d41b7e77e012215f0e1","24":"73fe6db63d1681a6b732","25":"31661cabe90e4b0eab47","26":"c2a127de5cf854730d20","27":"e969b9625352102d1b37","28":"487ba7acd8c0372b008a","29":"6a8b908703d5675e79d6","30":"2e8b10508f9d8e49e7a6","31":"049f544e29c1fb5b0a7f","32":"73cd565bf88fefbf90e1","33":"f7e41a9d67ed3e9824e8","34":"ee83038f5f748c239381","35":"4dbe2d9f302e36b2d375","36":"d8e94110cbe7245b931b","37":"b49ee008c605038a52ca","38":"bf2a85dffbf2c5b88a5e","39":"f76fb84b71470467c1a0","40":"5570b6c51f4b92f6bc6e","41":"386681e9738168f9422d","42":"8a0f71e56a1a35337ecf","43":"9e2b30024eee1ae9d30b","44":"8ec07bb7b8b881c99bbf","45":"9f4eba8567c69401d435","46":"dc020072a8a63ce6c71b","47":"3fe1a6f0c93a65195a1a","48":"db28322e12ca73ed0a02","49":"b6d1c82b62b652acfeeb","50":"b5bbfe634fc3d88b7f1f","51":"514a4705b9c86facad1a","52":"228a944d94f0aa81de72","53":"33c5f5db085412e75c22","54":"62c98b03bb4ea3976d25","55":"5415db25fca9f125c75e","56":"28778cfbd978b42e7f25","57":"16095be54f8b1dac16b1","58":"dfee948de2576213e4d9","59":"2e72ae389fd458d49cc2","60":"a9a9f77d20587e0f499b","61":"24b17d416dfe0c6e71c6","62":"5eb5016deffb5b768fd0","63":"111e31d0df59cc197ffa","64":"ea33a4dc8a470e10838a","65":"fab826b0d9e27d221116","66":"49d81fbd3579002a05ec","67":"9eb6f46ab2648ce0437c","68":"52771b6d6256327c09ba","69":"a1a456326ec39293ea7e","70":"cf20c8d87a635e2e7da7","71":"ac94c964616423b938c8","72":"ec9c7e6dfccfd7a7ea8f","73":"d4150f45feb8a28da89a","74":"ca12db100f79dd8d2937","75":"bff36d2dcabbf90f597f","76":"20849203e51ed93d1444","77":"13284830f3df6e308789","78":"b68273ee84905dde2a51","79":"6adfe59666f9384ef321","80":"5e24667fe7a9b64def95","81":"bb9148dddb0d185d4000","82":"13076f69691509627502","83":"7f5eee31e7b28989ba5e","84":"b39f0a453a5ace5470fe","85":"b28f26d188c7480f022d","87":"1b00ee0fb9f3aa3da2d7","88":"c8658e754a439a7df213","89":"67d6089fbff8557277ec","90":"f3528f5beb24eaf8ec0c","91":"b0d9c89361b36504de86","92":"ee733443179f2f55db19","93":"859d35ad1841f313839e","94":"d7cee800b33bd07967b8","95":"5235405f30e714a9350d","96":"fd3127f20120f71b270a","97":"7f13eac674636d264ea9","98":"eaef8c98088524f96cc3","99":"8d2763265aec1201848a","100":"296b09fff7a90154f141","101":"d77d6e72dcc1334f09e7","102":"7e80723fa96a51de64db","103":"9007d2af7a1c284fac42","104":"c80ab04e0d0b9d403531","105":"5f93078de2e425f59147","106":"abe2d71457332e5841a2","107":"3a233abe65e0e9993411","108":"3b667e099a8f86054c3d","109":"57e0f3a486e021658418","110":"ff4336d75f34b4d764c4","111":"8d00e730a9f8ce567214","112":"df16431338c5c0883d28","113":"e152119b10889d99cd14","114":"ee68d46cfae07908604e","115":"1bdc55e66448cbb844ec","116":"9f7b52dee831aacf5b7b","117":"d9cf7eaaba77dab56424","118":"c4e0d47a1ed02f20c4d9","119":"71c021e6ab58b5953ed8","120":"fd4b309e0f286902e67f","121":"0d1047908f42cf811284","122":"0d312001f22b0865d962","123":"6a9e5a44daf3a27287d1","124":"9b750e32bf9e771e598b","125":"f08f69ddb14cbe726ee9","126":"63266222a9612cd46e20","127":"5dd94799d4b4805be430","128":"e582e854234c2d9e382b","129":"823998c6e9c6bca34c8c","130":"a54c6eba98ba3e85365b","131":"9b637d77cbd7090253c5","132":"0be0717645be1864fed8","133":"88eb28ba16c975ef6238","134":"26f545384ef7b75a55ea","135":"9c4a079f162066b38044","136":"cb194debe1fe7475ea5e","137":"6adc98ba7ee4a60d32c1","138":"4d55f7e2957ab7a1985c","139":"677f47a497c54a097d00","140":"a0752a866c8278238c5d","141":"903dcf23e056b8179e9d","142":"afd6c4786009fb966dd7","143":"86ac0b827a3e2f666b1b","144":"078ce2f9b40ec871cd00","145":"dfa0eac7a61d9f7f8a88","146":"98fbb5b88c80554e68da","147":"362ffeade5f586456746","148":"5235fa5aa7521107b7fa","149":"6a4b0dedf6e9308ed696","150":"197905ee25019523d4c7","151":"4b8ff995505bdd65c8fa","152":"1c7f948d1a014e42e57e","153":"243ee934611cbabaa3c7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([862,154,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
